import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Grid, Notification, Typography } from '@applyboard/ui-components';
import Tag from "./Tag";
import { RawTypography, TagGroup, SummaryFieldsTypography } from "./style";
var Summary = function Summary(_ref) {
  var id = _ref.id,
    title = _ref.title,
    description = _ref.description,
    currentStage = _ref.currentStage,
    finalStage = _ref.finalStage,
    category = _ref.category,
    entityLevel = _ref.entityLevel,
    status = _ref.status,
    tags = _ref.tags,
    isEarlyAccess = _ref.isEarlyAccess;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: 2.5
  }, /*#__PURE__*/React.createElement(Typography, {
    mb: 1,
    variant: "h6",
    component: "h6"
  }, title), /*#__PURE__*/React.createElement(RawTypography, {
    variant: "caption",
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, isEarlyAccess && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Notification, {
    mb: 2.5,
    color: "info"
  }, "This is an Early Access requirement")), /*#__PURE__*/React.createElement(Rows, {
    id: id,
    currentStage: currentStage,
    finalStage: finalStage,
    category: category,
    entityLevel: entityLevel,
    status: status,
    tags: tags,
    isEarlyAccess: isEarlyAccess
  })));
};
function Rows(_ref2) {
  var id = _ref2.id,
    currentStage = _ref2.currentStage,
    finalStage = _ref2.finalStage,
    category = _ref2.category,
    entityLevel = _ref2.entityLevel,
    status = _ref2.status,
    tags = _ref2.tags,
    isEarlyAccess = _ref2.isEarlyAccess;
  var tagElements = tags.map(function (tag, index) {
    return /*#__PURE__*/React.createElement(Tag, {
      key: "".concat(id, "-").concat(index, "-").concat(tag),
      tagId: tag
    });
  });
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 12,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React.createElement(SummaryFieldsTypography, {
    variant: "caption"
  }, isEarlyAccess ? 'Current Stage' : 'Stage'), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, currentStage)), isEarlyAccess && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React.createElement(SummaryFieldsTypography, {
    variant: "caption"
  }, "Final Stage"), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, finalStage)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React.createElement(SummaryFieldsTypography, {
    variant: "caption"
  }, "Category"), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, category)), entityLevel && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React.createElement(SummaryFieldsTypography, {
    variant: "caption"
  }, "Entity Level"), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, entityLevel)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React.createElement(SummaryFieldsTypography, {
    variant: "caption"
  }, "Status"), /*#__PURE__*/React.createElement(TagGroup, null, /*#__PURE__*/React.createElement(Tag, {
    tagId: status
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React.createElement(SummaryFieldsTypography, {
    variant: "caption"
  }, "Tags"), /*#__PURE__*/React.createElement(TagGroup, null, tagElements)));
}
export default Summary;